export { default } from "./BlockQuoteSimple";
